'use strict';

const Backbone = require('backbone');
const Moment = require('moment');
const UserRequestCommentModel = require('../entity/comment');

module.exports = Backbone.Collection.extend({
    model: UserRequestCommentModel,

    comparator: function(comment) {
        const t = comment.get('updatedAt');
        return - Moment(t).unix();
    }
});



// WEBPACK FOOTER //
// ./feedback/domain/collection/comment.js